import { alpha } from '@mui/material/styles';
import type { Components, Theme } from '@mui/material/styles';

export const navigationComponents: Components<Theme> = {
    MuiListItemButton: {
        styleOverrides: {
            root: ({ theme }) => ({
                borderRadius: 12,
                transition: theme.transitions.create(
                    ['background-color', 'color', 'transform'],
                    { duration: 150 },
                ),
                '&:hover': {
                    backgroundColor: theme.palette.action.hover,
                },
                '&.active:hover': {
                    color:
                        theme.palette.mode === 'dark'
                            ? theme.palette.primary.light
                            : theme.palette.primary.main,
                    backgroundColor: alpha(
                        theme.palette.mode === 'dark'
                            ? theme.palette.primary.light
                            : theme.palette.primary.main,
                        theme.palette.mode === 'dark' ? 0.14 : 0.075,
                    ),
                },
            }),
        },
    },

    MuiListItemIcon: {
        styleOverrides: {
            root: {
                minWidth: 0,
            },
        },
    },

    MuiListSubheader: {
        styleOverrides: {
            root: ({ theme }) => ({
                '&.MuiAutocomplete-groupLabel': {
                    color: theme.palette.primary.main,
                    fontWeight: 650,
                    fontSize: 14,
                },
            }),
        },
    },

    MuiTab: {
        styleOverrides: {
            root: ({ theme }) => ({
                minHeight: 42,
                minWidth: 0,
                paddingInline: 14,
                borderRadius: 10,
                color: theme.palette.text.secondary,
                opacity: 1,
                fontWeight: 600,
                transition: theme.transitions.create(
                    ['background-color', 'color'],
                    { duration: 150 },
                ),
                '&:hover': {
                    color: theme.palette.text.primary,
                    backgroundColor: theme.palette.action.hover,
                },
                '&.Mui-selected': {
                    color: theme.palette.primary.main,
                    opacity: 1,
                },
                '&.Mui-disabled': {
                    color: theme.palette.text.disabled,
                    opacity: theme.palette.action.disabledOpacity,
                },
            }),
        },
    },

    MuiTabs: {
        styleOverrides: {
            root: {
                minHeight: 42,
            },
            indicator: ({ theme }) => ({
                height: 3,
                borderRadius: '3px 3px 0 0',
                backgroundColor: theme.palette.primary.main,
            }),
        },
    },

    MuiBreadcrumbs: {
        styleOverrides: {
            root: ({ theme }) => ({
                color: theme.palette.text.secondary,
            }),
            separator: ({ theme }) => ({
                color: theme.palette.text.disabled,
            }),
        },
    },

    MuiPaginationItem: {
        styleOverrides: {
            root: ({ theme }) => ({
                minWidth: 34,
                height: 34,
                borderRadius: 10,
                fontWeight: 600,
                '&.Mui-selected': {
                    color: theme.palette.primary.contrastText,
                    backgroundColor: theme.palette.primary.main,
                    boxShadow: `0 6px 16px ${alpha(theme.palette.primary.main, 0.18)}`,
                    '&:hover': {
                        backgroundColor: theme.palette.primary.dark,
                    },
                },
            }),
        },
    },
};
